import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers';

export default (initialState = {}) => {
  const composeEnhancers =
    process.env.NODE_ENV === 'development'
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
      : compose;
  const enhacer = compose(composeEnhancers(applyMiddleware(thunk)));

  return { store: createStore(reducer, initialState, enhacer) };
};
